import { useContext, Dispatch } from "react";

import { StateContext } from "config/state";

export const initialState = {
  learningPlansFilters: {
    pagination: { rowsPerPage: 10 },
    orderBy: ["name,ASC"]
  }
};

type State = typeof initialState;

export enum actionTypes {
  SET_LEARNING_PLAN_FILTERS = "setLearningPlanFilters",
  RESET_LEARNING_PLAN_FILTERS = "resetLearningPlanFilters"
}

const reducer = (
  state = initialState,
  action: { type: actionTypes; payload?: any }
) => {
  switch (action.type) {
    case actionTypes.SET_LEARNING_PLAN_FILTERS: {
      return {
        ...state,
        learningPlansFilters: action.payload
      };
    }
    case actionTypes.RESET_LEARNING_PLAN_FILTERS: {
      return {
        ...state,
        learningPlansFilters: initialState.learningPlansFilters
      };
    }
    default:
      return state;
  }
};

export const useModuleState = (): [
  State,
  Dispatch<{ type: actionTypes; payload?: any }>
] => {
  const [state, dispatch] = useContext(StateContext);
  return [state.learningPlans, dispatch];
};

export default reducer;
